module.exports = __webpack_public_path__ + "static/media/canais-4.130f173f.jpg";